import React from "react";
import { Box, Typography } from "@mui/material";
import FileCopyIcon from "@mui/icons-material/FileCopy";
import { Visibility } from "@mui/icons-material";

const UploadedFilesPreview = ({
  billsObjName,
  category,
  billsObj,
  billsObjFileObjects,
  setPreviewModal,
  onDelete,
  DeleteIcon,
}) => {
    const handlePreviewClick = (fileObject, previewUrl, isPdf, fileName) => {
      if (fileObject instanceof Blob || previewUrl) {
        let url = previewUrl;

        if (isPdf && fileObject instanceof Blob) {
          try {
            url = URL.createObjectURL(fileObject);
          } catch (error) {
            console.error("Error creating PDF URL:", error);
            return;
          }
        }

        if (url) {
          setPreviewModal({
            open: true,
            url: url,
            isPdf: isPdf,
            name: fileName,
            fileObject: fileObject,
          });
        }
      }
    };
  return (
    <Box
      sx={{
        mt: 2,
        display: "flex",
        flexWrap: "wrap",
        gap: 2,
      }}
    >
      {Array.from(billsObjName[category]).map((row, idx) => {
        const fileKey = billsObj[category]?.[idx];
        const fileObject =
          billsObjFileObjects[category]?.[idx];
        let previewUrl = null;
        let isPdf = false;

        if (fileObject && fileObject instanceof Blob) {
          isPdf = fileObject.type === "application/pdf";
          if (!isPdf) {
            try {
              previewUrl = URL.createObjectURL(fileObject);
            } catch (error) {
              previewUrl = null;
            }
          }
        } else {
          isPdf = fileKey?.toLowerCase().endsWith(".pdf");
        }

        return (
          <Box
            key={idx}
            sx={{
              position: "relative",
              width: {
                xs: "140px",
                sm: "160px",
              },
              height: {
                xs: "180px",
                sm: "200px",
              },
              borderRadius: "12px",
              border: "1px solid #E5E7EB",
              backgroundColor: "#FFFFFF",
              overflow: "visible",
              boxShadow: "0 1px 3px rgba(0, 0, 0, 0.1)",
            }}
          >
            <Box
              sx={{
                width: "100%",
                height: {
                  xs: "130px",
                  sm: "150px",
                },
                backgroundColor: "#F9FAFB",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "relative",
                overflow: "visible",
                borderRadius: "12px 12px 0 0",
              }}
            >
              {isPdf ? (
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#FEF2F2",
                    gap: 1,
                  }}
                >
                  <FileCopyIcon
                    sx={{
                      fontSize: {
                        xs: "40px",
                        sm: "48px",
                      },
                      color: "#EF4444",
                    }}
                  />
                  <Typography
                    sx={{
                      fontSize: {
                        xs: "14px",
                        sm: "16px",
                      },
                      fontWeight: "700",
                      color: "#EF4444",
                      letterSpacing: "0.5px",
                    }}
                  >
                    PDF
                  </Typography>
                </Box>
              ) : previewUrl ? (
                <img
                  src={previewUrl}
                  alt={row}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              ) : (
                <Box
                  sx={{
                    width: "100%",
                    height: "100%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    backgroundColor: "#F3F4F6",
                    backgroundImage:
                      "linear-gradient(45deg, #f0f0f0 25%, transparent 25%, transparent 75%, #f0f0f0 75%, #f0f0f0), linear-gradient(45deg, #f0f0f0 25%, transparent 25%, transparent 75%, #f0f0f0 75%, #f0f0f0)",
                    backgroundSize: "20px 20px",
                    backgroundPosition: "0 0, 10px 10px",
                  }}
                >
                  <FileCopyIcon
                    sx={{
                      fontSize: {
                        xs: "40px",
                        sm: "48px",
                      },
                      color: "#EF4444",
                    }}
                  />
                </Box>
              )}
              <Box
                sx={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  width: {
                    xs: "40px",
                    sm: "48px",
                  },
                  height: {
                    xs: "40px",
                    sm: "48px",
                  },
                  borderRadius: "50%",
                  backgroundColor: "rgba(255, 255, 255, 0.95)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                  transition: "all 0.2s ease",
                  opacity: 0.9,
                  "&:hover": {
                    backgroundColor: "#FFFFFF",
                    transform: "translate(-50%, -50%) scale(1.1)",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.2)",
                    opacity: 1,
                  },
                }}
                onClick={() =>
                  handlePreviewClick(fileObject, previewUrl, isPdf, row)
                }
              >
                <Visibility
                  sx={{
                    fontSize: {
                      xs: "20px",
                      sm: "24px",
                    },
                    color: "#0066DC",
                  }}
                />
              </Box>
              <Box
                sx={{
                  position: "absolute",
                  top: "-12px",
                  right: "-12px",
                  width: "28px",
                  height: "28px",
                  borderRadius: "50%",
                  backgroundColor: "#ffffff",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  zIndex: 10,
                  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                }}
                onClick={() => onDelete?.(idx)}
              >
                <img src={DeleteIcon} alt="Delete" height="16px" width="16px" />
              </Box>
            </Box>

            <Box
              sx={{
                padding: {
                  xs: "8px",
                  sm: "10px",
                },
                height: {
                  xs: "50px",
                  sm: "50px",
                },
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderTop: "1px solid #E5E7EB",
              }}
            >
              <Typography
                sx={{
                  fontSize: {
                    xs: "11px",
                    sm: "12px",
                  },
                  color: "#252D38",
                  fontWeight: 400,
                  textAlign: "center",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  display: "flex",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  lineHeight: "1.3",
                }}
              >
                {row}
              </Typography>
            </Box>
          </Box>
        );
      })}
    </Box>
  );
};

export default UploadedFilesPreview;